/*
	日期：2025/08/25
	地点：四川 成都
	作者：终结司令官
	
	介绍：首页数据模拟
	
	- Powered by finalcommander.com
	- Supported by IOE.TOP
*/

//mock数据模拟
import Mock from 'mockjs';

// 图表数据
let List = [];
export default {
	getstatisticalData: () => {
		//Mock.Random.float 产生随机数100到8008之间保留小数 最小0位 最大8位
		for(let i=0; i<7; i++) {
			List.push(
				Mock.mock({
					苹果: Mock.Random.float(100,8000,0,0),
					vivo: Mock.Random.float(100,8000,0,0),
					oppo: Mock.Random.float(100,8000,0,0),
					魅族: Mock.Random.float(100,8000,0,0),
					三星: Mock.Random.float(100,8000,0,0),
					小米: Mock.Random.float(100,8000,0,0),
				})
			);
		};
		return {
			code: 20000,
			data: {
				tableData: [{
					date: '2016-05-02',
					name: '王虎',
					address: '上海市普陀区金沙江路 1518 1弄'
				}, {
					date: '2016-05-04',
					name: '张三',
					address: '上海市普陀区金沙江路 1517 弄'
				}, {
					date: '2016-05-01',
					name: '李四',
					address: '上海市普陀区金沙江路 1519 弄'
				}, {
					date: '2016-05-03',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1516 弄'
				}],
				tableLabel: {
					date: '日期',
					name: '姓名',
					address: '地址',
				},
				// 饼图
				videoData:[
					{
						name: '小米',
						value: 2999,
					},
					{
						name: '苹果',
						value: 5999,
					},
					{
						name: 'vivo',
						value: 1900,
					},
					{
						name: 'oppo',
						value: 1999,
					},
					{
						name: '魅族',
						value: 2200,
					},
					{
						name: '三星',
						value: 4500,
					},
				],
				//柱状图
				userData: [
					{
						﻿date:'周一',
						new: 5,
						active: 200,
					},
					{
						﻿date:'周二',
						new: 10,
						active: 500,
					},
					{
						﻿date:'周三',
						new: 5,
						active: 200,
					},
					{
						﻿date:'周四',
						new: 10,
						active: 500,
					},
					{
						﻿date:'周五',
						new: 5,
						active: 200,
					},
					{
						﻿date:'周六',
						new: 10,
						active: 500,
					},
					{
						﻿date:'周日',
						new: 10,
						active: 500,
					},
				],
				﻿table1Data:[
					{
						name: 'oppo',
						todayBuy: 500,
						monthBuy: 3500,
						totalBuy: 22080,
					},
					{
						name: 'viyo',
						todayBuy: 300,
						monthBuy: 2200,
						totalBuy: 24000,
					},
					{
						name: '苹果',
						todayBuy: 800,
						monthBuy: 4500,
						totalBuy: 65000,
					},
					{
						name: '小米',
						todayBuy: 1200,
						monthBuy: 6500,
						totalBuy: 45000,
					},
					{
						name: '三星',
						todayBuy: 300,
						monthBuy: 2000,
						totalBuy: 34000,
					},
					{
						name: '魅族',
						todayBuy: 350,
						monthBuy: 3800,
						totalBuy: 22000,
					},
				],
				orderData: {
					data: [
						{
							苹果: 2493,
							oppo: 2493,
							viyo: 2493,
							小米: 2493,
							三星: 2493,
							魅族: 2493,
						},
						{
							苹果: 2342,
							oppo: 1234,
							viyo: 3213,
							小米: 12312,
							三星: 1223,
							魅族: 4321,
						},
						{
							苹果: 2123,
							oppo: 4334,
							viyo: 2312,
							小米: 3323,
							三星: 4322,
							魅族: 1232,
						},
						{
							苹果: 1122,
							oppo: 3234,
							viyo: 2323,
							小米: 1212,
							三星: 1212,
							魅族: 4343,
						},
						{
							苹果: 1232,
							oppo: 3421,
							viyo: 1231,
							小米: 3214,
							三星: 2123,
							魅族: 1232,
						},
						{
							苹果: 4343,
							oppo: 3434,
							viyo: 3443,
							小米: 3434,
							三星: 1212,
							魅族: 1212,
						},
						{
							苹果: 2493,
							oppo: 2493,
							viyo: 2493,
							小米: 2493,
							三星: 2493,
							魅族: 2493,
						},
					],
					date: [
						'20250801','20250802','20250803','20250804','20250805','20250806','20250807',
					],
				}
			}
		}
	}
}

